// helpers.ts
export const groupBy = <T, K extends string | number | symbol>(
  array: T[],
  fn: (item: T) => K
): Record<K, T[]> =>
  array.reduce(
    (result, item) => {
      const key = fn(item);
      if (!result[key]) result[key] = [];
      result[key].push(item);
      return result;
    },
    {} as Record<K, T[]>
  );
